import React from "react";

export default function PrivacyPolicy() {
  return (
    <div className="max-w-4xl mx-auto px-6 py-12">
      <h1 className="text-4xl font-bold mb-4">Privacy Policy</h1>

      <p className="text-gray-600 mb-8">
        Effective Date: January 1, 2025 | Last Updated: January 1, 2025
      </p>

      <section className="space-y-6">
        <p>
          SoftConcern Technologies LLP ("SoftConcern", "we", "our", or "us")
          values your privacy. This Privacy Policy explains how we collect,
          use, disclose, and safeguard your information when you visit our
          website, use our services, mobile applications, WhatsApp Business
          communications, and related digital platforms.
        </p>

        <div>
          <h2 className="text-2xl font-semibold mb-3">
            1. Information We Collect
          </h2>

          <ul className="list-disc pl-6 space-y-2">
            <li>Name and contact information.</li>
            <li>Email address and phone number.</li>
            <li>Business details provided through contact forms.</li>
            <li>WhatsApp communication details.</li>
            <li>Website usage data and analytics.</li>
            <li>Device information, browser type, and IP address.</li>
            <li>Information submitted for project inquiries or support.</li>
          </ul>
        </div>

        <div>
          <h2 className="text-2xl font-semibold mb-3">
            2. How We Use Your Information
          </h2>

          <ul className="list-disc pl-6 space-y-2">
            <li>To provide and improve our services.</li>
            <li>To respond to inquiries and support requests.</li>
            <li>To communicate project updates and business information.</li>
            <li>To send service notifications and important updates.</li>
            <li>To comply with legal obligations.</li>
            <li>To analyze website performance and user experience.</li>
          </ul>
        </div>

        <div>
          <h2 className="text-2xl font-semibold mb-3">
            3. WhatsApp Communication
          </h2>

          <p>
            By contacting us through WhatsApp Business, you consent to receive
            messages related to inquiries, support, project discussions,
            appointments, and service updates. We do not sell or share your
            WhatsApp information with third parties for marketing purposes.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-semibold mb-3">4. Cookies</h2>

          <p>
            We may use cookies and similar technologies to improve website
            functionality, analyze traffic, and enhance user experience. You may
            disable cookies through your browser settings.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-semibold mb-3">
            5. Sharing of Information
          </h2>

          <p>
            We do not sell, rent, or trade personal information. Information
            may be shared only with trusted service providers, legal
            authorities, or partners when necessary to provide services or
            comply with legal requirements.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-semibold mb-3">
            6. Data Security
          </h2>

          <p>
            We implement reasonable administrative, technical, and physical
            security measures to protect personal information from unauthorized
            access, disclosure, alteration, or destruction.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-semibold mb-3">
            7. Third-Party Services
          </h2>

          <p>
            Our website and applications may use third-party services such as
            Google Analytics, cloud hosting providers, payment gateways, social
            media integrations, and communication platforms. Their privacy
            practices are governed by their respective policies.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-semibold mb-3">
            8. Your Rights
          </h2>

          <p>
            Depending on applicable laws, you may have the right to access,
            correct, update, or delete your personal information. You may also
            request details regarding how your information is processed.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-semibold mb-3">
            9. Children's Privacy
          </h2>

          <p>
            Our services are not intended for children under 13 years of age.
            We do not knowingly collect personal information from children.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-semibold mb-3">
            10. Changes to This Policy
          </h2>

          <p>
            We may update this Privacy Policy from time to time. Any changes
            will be posted on this page with an updated revision date.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-semibold mb-3">
            11. Contact Us
          </h2>

          <p>
            If you have questions regarding this Privacy Policy, please contact
            us:
          </p>

          <div className="mt-3 bg-gray-100 p-4 rounded-lg">
            <p>
              <strong>SoftConcern Technologies LLP</strong>
            </p>
            <p>Email: info@softconcern.com</p>
            <p>Website: https://softconcern.com</p>
          </div>
        </div>
      </section>
    </div>
  );
}